// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3D0TD","title":"styles_title__34-O1"};